import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';

const propTypes = {
  classes: PropTypes.shape({}).isRequired,
};
const defaultProps = {};
const styles = () => ({});
function DeleteButton(props) {
  const { classes, ...others } = props;
  return (
    <IconButton color="primary" {...others} aria-label="Delete">
      <DeleteIcon fontSize="small" />
    </IconButton>
  );
}
DeleteButton.propTypes = propTypes;
DeleteButton.defaultProps = defaultProps;
export default withStyles(styles)(DeleteButton);
